"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DivNote = DivNote;
exports.FormHospital = FormHospital;
var react_1 = __importStar(require("react"));
var api_1 = require("../api");
var react_toastify_1 = require("react-toastify");
function DivNote() {
    return (react_1.default.createElement("div", { className: "div-nite" },
        "\u2191",
        react_1.default.createElement("br", null),
        react_1.default.createElement("span", { style: { writingMode: "vertical-rl" } }, "\u4E0A\u4E0B\u6ED1\u52A8"),
        react_1.default.createElement("br", null),
        "\u2193"));
}
function FormHospital() {
    var _this = this;
    var _a;
    var _b = (0, react_1.useState)({}), lisUrls = _b[0], setLisUrls = _b[1];
    var _c = (0, react_1.useState)([]), hospitals = _c[0], setHospitals = _c[1];
    var _d = (0, react_1.useState)({
        hospital_id: "",
        hospital: "",
        lis_url_key: "",
    }), hospitalProps = _d[0], setHospitalProps = _d[1];
    var prevHospitalRef = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(function () {
        if (!prevHospitalRef.current) {
            loadLisUrls();
            loadHospitals();
            prevHospitalRef.current = true;
        }
    }, []);
    var loadLisUrls = function () { return __awaiter(_this, void 0, void 0, function () {
        var urls, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0, api_1.getLisUrls)()];
                case 1:
                    urls = _a.sent();
                    setLisUrls(urls);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error("Error loading lisUrls:", error_1);
                    react_toastify_1.toast.error("加载报告上传地址失败", api_1.toastOptions);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var loadHospitals = function () { return __awaiter(_this, void 0, void 0, function () {
        var _a, error_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    _a = setHospitals;
                    return [4 /*yield*/, (0, api_1.getHospitals)()];
                case 1:
                    _a.apply(void 0, [_b.sent()]);
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _b.sent();
                    console.error("Error loading hospitals:", error_2);
                    react_toastify_1.toast.error("加载送检单位失败", api_1.toastOptions);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleChange = function (e) {
        var _a;
        var _b = e.target, name = _b.name, value = _b.value;
        setHospitalProps(__assign(__assign({}, hospitalProps), (_a = {}, _a[name] = value, _a)));
    };
    var handleSubmit = function (event) { return __awaiter(_this, void 0, void 0, function () {
        var response, json, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch("/xdh1-api/hospitals/add", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(hospitalProps),
                        })];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    json = _a.sent();
                    if (json.code === 0) {
                        react_toastify_1.toast.info(json.message, api_1.toastOptions);
                        setHospitalProps({
                            hospital_id: "",
                            hospital: "",
                            lis_url_key: "",
                        });
                        loadHospitals();
                    }
                    else {
                        react_toastify_1.toast.error(json.message, api_1.toastOptions);
                    }
                    return [3 /*break*/, 5];
                case 4:
                    error_3 = _a.sent();
                    console.error("Error submitting form:", error_3);
                    react_toastify_1.toast.error("新增失败，请检查网络连接", api_1.toastOptions);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleUpdate = function (hospitalId) { return __awaiter(_this, void 0, void 0, function () {
        var payload, response, json, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    payload = {
                        hospital_id: hospitalId,
                        lis_url_key: hospitalProps.lis_url_key,
                    };
                    return [4 /*yield*/, fetch("/xdh1-api/hospitals/update", {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify(payload),
                        })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    json = _a.sent();
                    if (json.code === 0) {
                        loadHospitals();
                    }
                    else {
                        react_toastify_1.toast.info(json.message, api_1.toastOptions);
                    }
                    return [2 /*return*/, json.data];
                case 3:
                    error_4 = _a.sent();
                    console.error("Error deleting form:", error_4);
                    react_toastify_1.toast.error("更新失败，请检查网络连接", api_1.toastOptions);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleDelete = function (hospitalId) { return __awaiter(_this, void 0, void 0, function () {
        var payload, response, json, error_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    payload = { hospital_id: hospitalId };
                    return [4 /*yield*/, fetch("/xdh1-api/hospitals/delete", {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify(payload),
                        })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    json = _a.sent();
                    if (json.code === 0) {
                        loadHospitals();
                    }
                    else {
                        react_toastify_1.toast.info(json.message, api_1.toastOptions);
                    }
                    return [2 /*return*/, json.data];
                case 3:
                    error_5 = _a.sent();
                    console.error("Error deleting form:", error_5);
                    react_toastify_1.toast.error("删除失败，请检查网络连接", api_1.toastOptions);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("div", { className: "form-container" },
        react_1.default.createElement("div", { className: "div-form" },
            react_1.default.createElement("form", { className: "zmsk-form hospital-form", onSubmit: handleSubmit },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("table", null,
                        react_1.default.createElement("colgroup", null,
                            react_1.default.createElement("col", { style: { width: "10%" } }),
                            react_1.default.createElement("col", { style: { width: "25%" } }),
                            react_1.default.createElement("col", { style: { width: "15%" } }),
                            react_1.default.createElement("col", { style: { width: "35%" } }),
                            react_1.default.createElement("col", { style: { width: "15%" } })),
                        react_1.default.createElement("thead", null,
                            react_1.default.createElement("tr", null,
                                react_1.default.createElement("th", null, "\u7F16\u53F7"),
                                react_1.default.createElement("th", null, "\u9001\u68C0\u5355\u4F4D"),
                                react_1.default.createElement("th", null, "\u62A5\u544A\u4E0A\u4F20\u5730\u5740"),
                                react_1.default.createElement("th", null, "\u670D\u52A1\u5730\u5740"),
                                react_1.default.createElement("th", null, "\u64CD\u4F5C"))),
                        react_1.default.createElement("tbody", null,
                            react_1.default.createElement("tr", null,
                                react_1.default.createElement("td", null,
                                    react_1.default.createElement("input", { type: "text", name: "hospital_id", value: hospitalProps.hospital_id, onChange: handleChange })),
                                react_1.default.createElement("td", null,
                                    react_1.default.createElement("input", { type: "text", name: "hospital", value: hospitalProps.hospital, onChange: handleChange })),
                                react_1.default.createElement("td", null,
                                    react_1.default.createElement("select", { name: "lis_url_key", value: hospitalProps.lis_url_key, onChange: handleChange },
                                        react_1.default.createElement("option", null, "\u8BF7\u9009\u62E9"),
                                        Object.entries(lisUrls).map(function (_a) {
                                            var lisUrlKey = _a[0], info = _a[1];
                                            return (react_1.default.createElement("option", { key: lisUrlKey, value: lisUrlKey }, info.city));
                                        }))),
                                react_1.default.createElement("td", null,
                                    react_1.default.createElement("span", null, (_a = lisUrls === null || lisUrls === void 0 ? void 0 : lisUrls[hospitalProps.lis_url_key]) === null || _a === void 0 ? void 0 : _a.lis_url)),
                                react_1.default.createElement("td", null,
                                    react_1.default.createElement("button", { type: "submit", className: "zmsk-button" }, "\u65B0\u589E")))))),
                react_1.default.createElement("div", { className: "table-container" },
                    react_1.default.createElement("table", null,
                        react_1.default.createElement("colgroup", null,
                            react_1.default.createElement("col", { style: { width: "10%" } }),
                            react_1.default.createElement("col", { style: { width: "25%" } }),
                            react_1.default.createElement("col", { style: { width: "15%" } }),
                            react_1.default.createElement("col", { style: { width: "35%" } }),
                            react_1.default.createElement("col", { style: { width: "15%" } })),
                        react_1.default.createElement("tbody", null, hospitals.map(function (hospital, index) {
                            var _a;
                            return (react_1.default.createElement("tr", { key: index }, hospital.lis_url_key ? (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement("td", null, hospital.hospital_id),
                                react_1.default.createElement("td", null, hospital.hospital),
                                react_1.default.createElement("td", null, lisUrls[hospital.lis_url_key].city),
                                react_1.default.createElement("td", null, lisUrls[hospital.lis_url_key].lis_url),
                                react_1.default.createElement("td", null,
                                    react_1.default.createElement("button", { type: "button", className: "zmsk-button", onClick: function () {
                                            return handleDelete(hospital.hospital_id);
                                        } }, "\u5220\u9664")))) : (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement("td", null, hospital.hospital_id),
                                react_1.default.createElement("td", null, hospital.hospital),
                                react_1.default.createElement("td", null,
                                    react_1.default.createElement("select", { name: "lis_url_key", value: hospitalProps.lis_url_key, onChange: handleChange },
                                        react_1.default.createElement("option", null, "\u8BF7\u9009\u62E9"),
                                        Object.entries(lisUrls).map(function (_a) {
                                            var lis_url_key = _a[0], info = _a[1];
                                            return (react_1.default.createElement("option", { key: lis_url_key, value: lis_url_key }, info.city));
                                        }))),
                                react_1.default.createElement("td", null, (_a = lisUrls === null || lisUrls === void 0 ? void 0 : lisUrls[hospitalProps
                                    .lis_url_key]) === null || _a === void 0 ? void 0 : _a.lis_url),
                                react_1.default.createElement("td", null,
                                    react_1.default.createElement("button", { type: "button", className: "zmsk-button", onClick: function () {
                                            return handleUpdate(hospital.hospital_id);
                                        } }, "\u66F4\u65B0"),
                                    react_1.default.createElement("button", { type: "button", className: "zmsk-button", onClick: function () {
                                            return handleDelete(hospital.hospital_id);
                                        } }, "\u5220\u9664"))))));
                        })))))),
        hospitals.length > 5 && react_1.default.createElement(DivNote, null)));
}
